import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { CalculationStatisticStoreTypeResponse } from '@ydistri/api-sdk';
import { useTemplateOrCalculation } from '../../../hooks/useTemplateOrCalculation';
import { ReduxState } from '../../../store';
import StatisticDimensionSection from './components/StatisticDimensionSection';
import { useGetStatsStoreTypesQuery } from './apiCalculationStatistics';

const SectionStoreTypes: React.FC = () => {
  const templateOrCalculation = useTemplateOrCalculation();
  const departmentId = useSelector((state: ReduxState) => state.statistics.departmentId);
  const { data, isLoading } = useGetStatsStoreTypesQuery({
    calculationId: templateOrCalculation.id,
    departmentId,
  });

  const getItemTitle = useCallback(
    (item: CalculationStatisticStoreTypeResponse) => item.storeType.name,
    [],
  );
  const getItemKey = useCallback(
    (item: CalculationStatisticStoreTypeResponse) => `${item.storeType.id}`,
    [],
  );

  return (
    <StatisticDimensionSection
      title="Store types"
      tableId="store-type-statistics"
      dimensionColumnTitle="Store type"
      data={data}
      loading={isLoading}
      getItemTitle={getItemTitle}
      getItemKey={getItemKey}
    />
  );
};

export default SectionStoreTypes;
